<!-- ----------------------------------------------- -->
<template>
  <v-card :flat="isSmall" class="com-mb-card" :class="isSmall ? 'mt-0' : ''">
    <v-col v-show="!isSmall" class="com-mb-card-contents pa-1">
      <v-row>
        <v-col class="py-0 pl-6">
          <span class="pr-3">{{ text.title }}</span>
          <v-btn class="mx-0" icon @click="postFacebook()">
            <img
              class="sns-mb-icon"
              src="/kawabou/img/sns_icons/facebook.png"
            />
          </v-btn>
          <v-btn class="mx-0" icon @click="postTwitter()">
            <img class="sns-mb-icon" src="/kawabou/img/sns_icons/twitter.png" />
          </v-btn>
          <v-btn class="mx-0" icon @click="textLine()">
            <img class="sns-mb-icon" src="/kawabou/img/sns_icons/line.png" />
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [mb]レーダ雨量画面 SNS共有カード
 * RdSns.vue
 * @author LIS
 */
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "rd-sns",
  data() {
    return {
      dispOverlay: false,
      text: {
        title: "SNS共有",
      },
    };
  },
  computed: {
    /** 地域名 */
    areaName: {
      get() {
        let map = this.$store.state.map;
        return map.prefName + map.townName;
      },
    },
    /** LINE投稿テキスト */
    lineText: {
      get() {
        return this.$store.state.sns.lineText;
      },
    },
  },
  imageTimeOut: {
    get() {
      return this.$store.state.app.config.snsConfig.twitter.imageTimeOut;
    },
  },
  props: ["isSmall"],
  methods: {
    /** FaceBook投稿 */
    postFacebook() {
      // アクセスログ出力
      PageLog.log({
        page_log: "radar_sns",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        rader_sb: this.$store.state.radar.radarType,
        device_sb: this.$store.state.app.mode,
        sns: "fb",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.dispatch("sns/postFacebook", { url: location.href });
    },
    /** Twitter投稿 */
    async postTwitter() {
      const crentExp = this.isSmall;
      // 画面を最小化
      await this.$emit("showOverlay");
      await this.$emit("reductionWindow");

      // アクセスログ出力
      PageLog.log({
        page_log: "radar_sns",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        rader_sb: this.$store.state.radar.radarType,
        device_sb: this.$store.state.app.mode,
        sns: "tw",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.dispatch("sns/setTextRadar", {
        url: location.href,
        area: this.areaName,
      });

      await this.$store.dispatch("sns/getCapture", { type: "radar", imageTimeOut: this.imageTimeOut });
      this.getRequestToken();
      this.$emit("hideOverlay");
      if (!crentExp) {
        this.$emit("expansionWindow");
      }
    },
    /** Twitterリクエストトークンを取得 */
    getRequestToken() {
      this.$log.debug("[RdSns] getRequestToken()");
      const subWin = window.open("", "_blank");
      this.$store.dispatch("sns/getRequestToken", {subWin});
    },
    /** LINE投稿テキスト生成 */
    textLine() {
      this.$store.dispatch("sns/textLineRadar", {
        area: this.areaName,
      });
      this.$store.commit("sns/setType", "radar");
    },
    /** LINE投稿 */
    postLine() {
      // アクセスログ出力
      PageLog.log({
        page_log: "radar_sns",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        rader_sb: this.$store.state.radar.radarType,
        device_sb: this.$store.state.app.mode,
        sns: "ln",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.dispatch("sns/postLine", {
        lat: this.$route.query["clat"],
        lon: this.$route.query["clon"],
        mode: "mb",
      });
    },
  },
  watch: {
    /** LINE投稿テキスト */
    lineText() {
      if (this.lineText != null) {
        this.postLine();
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
